export default {
  LOCATION_CHANGED: 'app/Routing/LOCATION_CHANGED',
};
